import dayjs from 'dayjs';

import { FetchEmailsResponseType } from './useSearchEmails';

export interface EmailsDataSourceType {
  key: React.Key;
  from: string;
  sentDate: string;
  subject: string;
  message: string;
}

export const useEmailsTableDataSource = (data: FetchEmailsResponseType | undefined): EmailsDataSourceType[] => {
  if (!data) {
    return [];
  }

  const dataToMap = data.results;

  return dataToMap.map((element) => {
    return {
      key: element.uuid,
      sentDate: dayjs.unix(element.sentDate).format('DD-MM-YYYY'),
      from: element.from,
      subject: element.subject,
      message: element.body,
    };
  });
};
